/* eslint-disable max-lines-per-function */
import "./Headline.scss";
import { cn } from "tailwind-variants";

export default function Headline({ largeGap, children, slots, ...restProps }) {
  return (
    <div
      {...restProps}
      className={cn("scope-20b5d5db", restProps.className, "headline", {
        "headline--large-gap": largeGap
      })}
    >
      {children}
      <div className="headline__captions scope-20b5d5db">
        <div className="headline__title scope-20b5d5db">{slots?.title?.()}</div>
        <div className="headline__subtitle scope-20b5d5db">{slots?.subtitle?.()}</div>
      </div>
    </div>
  );
}
